enum Pregnant {
    PREGNANT = 'PREGNANT',
    NOT_PREGNANT = 'NOT_PREGNANT',
    PUERPERIUM = 'PUERPERIUM',
    UNDEFINED = 'UNDEFINED'
}

export default Pregnant;
